module.exports = __webpack_public_path__ + "img/YM.e2465052.png";